module.exports = __webpack_public_path__ + "img/none.73fe9b34.svg";